/**
 * 数组转为对象，便于查找，更新
 * @param arr 需要转化的数组
 * @param key 数组中对象的唯一标示
 */

import { ChatType } from '../constants/types';
import { getUid } from '../store/token';

export type FlattenObjType = { [key in string]: any };

export const flattenArray = (arr: any[], key: string) => {
    return arr.reduce((map, item) => {
        map[item[key]] = item;
        return map;
    }, {} as FlattenObjType);
};

/**
 * 检查tid是单聊或是群聊
 */
export const getTypeByTopicid = (tid: string) => {
    return tid.startsWith('g_') ? ChatType.GROUP : ChatType.SINGLE;
};

// 构建单聊topicID
export const buildSingleTopicId = (uid1: number, uid2: number): string => {
    if (uid1 <= uid2) {
        return `s_${uid1}_${uid2}`;
    } else {
        return `s_${uid2}_${uid1}`;
    }
};
export function parseIds(input: string): { id1: number; id2: number } | null {
    const match = input.match(/^s_(\d+)_(\d+)$/);
    if (!match) return null;

    const [, id1, id2] = match;
    return { id1: Number(id1), id2: Number(id2) };
}
/**
 * 根据tid获取单聊对象的id
 * @param tid 会话id
 * @returns
 */
export const parseSingleOther = (tid: string) => {
    const [type, ...uids] = tid.split('_');
    // 如果是单聊
    if (type === 's') {
        const uid = getUid();
        const [u1, u2] = uids.map(Number);
        if (u1 === uid && u2) {
            return u2;
        }

        if (u2 === uid && u1) {
            return u1;
        }

        return 0;
    }

    return 0;
};
